import React from "react";
import { PageHeader, List } from "antd";
import styles from "./OptinList.module.scss";
import {
    SnippetsOutlined,
    FilePdfOutlined,
    FileImageOutlined,
    VideoCameraOutlined,
} from "@ant-design/icons";
import { Template, TemplateType } from "frontend-lib/DomainTypes/Template";
import { useTranslation } from "react-i18next";
const { optInSelectTemplate, optInSelectTemplate__full, optInList__content } = styles;

type Props = {
    templates: Array<Template>;
    visible: boolean;
    closeCb: () => void;
    selectTemplateCb: (t: Template) => void;
};

function OptinSelectTemplate({ templates, visible, closeCb, selectTemplateCb }: Props) {
    const { t } = useTranslation();

    const templateIcon = (t: Template) => {
        const style = { fontSize: "1.5rem", marginTop: "0.7rem" };
        switch (t.templateType) {
            case TemplateType.DOCUMENT:
                return <FilePdfOutlined style={style} />;
            case TemplateType.IMAGE:
                return <FileImageOutlined style={style} />;
            case TemplateType.VIDEO:
                return <VideoCameraOutlined style={style} />;
            default:
                return <SnippetsOutlined style={style} />;
        }
    };

    return (
        <div className={`${optInSelectTemplate} ${visible && optInSelectTemplate__full}`}>
            <PageHeader onBack={() => closeCb()} title="" subTitle={t("outbound.selectTemplate")} />
            <div className={optInList__content}>
                <List
                    rowKey={(item) => item.id}
                    dataSource={templates}
                    renderItem={(template) => (
                        <List.Item>
                            <List.Item.Meta
                                key={template.key}
                                title={template.key}
                                avatar={templateIcon(template)}
                                description={
                                    <div
                                        style={{
                                            maxHeight: "2.8em",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "-webkit-box",
                                            WebkitLineClamp: "2", // Limit to two lines
                                            WebkitBoxOrient: "vertical",
                                        }}
                                    >
                                        {template.text}
                                    </div>
                                }
                                // @ts-ignore
                                onClick={() => selectTemplateCb(template)}
                            />
                        </List.Item>
                    )}
                />
            </div>
        </div>
    );
}
export default OptinSelectTemplate;
